// extracted by mini-css-extract-plugin
module.exports = {"PageNotFoundContainer":"PageNotFound_PageNotFoundContainer__YkmP0","blockPageNotFound":"PageNotFound_blockPageNotFound__PhLeX"};